import { useState } from "react";
import { Card } from "react-bootstrap";
import { ChevronExpand } from "react-bootstrap-icons";
import { Trans, useTranslation } from "react-i18next";
import { selectMeasurementType } from "../../../../store/slices/settingsSlice";
import { useSelector } from "react-redux";

function InfoBox() {
  const { t } = useTranslation(["translation", "fhwa"]);

  const [showResults, setShowResults] = useState(true);
  const onClick = () => setShowResults(!showResults);
  const metric = useSelector(selectMeasurementType);
  let isMetric = metric === 0;
  return (
    <div className="col-8" style={{ paddingTop: "10px" }}>
      <Card bg={"light"} key={1} text={"dark"} style={{ width: "100%" }} className="mb-2">
        <Card.Header onClick={onClick}>
          {t("InfoboxTitle", { ns: "fhwa" })}
          <button type="button" className="float-end" style={{ border: "none" }}>
            {showResults ? t("hideDetails") : t("showDetails")}
            <ChevronExpand style={{ marginLeft: "10px" }} />
          </button>
        </Card.Header>

        {showResults && (
          <Card.Body>
            <p>
              P = p D L<sub>req'd</sub> (d<sub>ult</sub> / F.S.) = p D L<sub>req'd</sub> da
            </p>
            <br />
            <dl style={{ color: "#3f3f40", fontSize: "12px" }}>
              <dt>P</dt>
              <dd>
                <Trans
                  i18nKey="InfoboxVar_1"
                  ns="fhwa"
                  values={{
                    unit: isMetric ? "kN" : "kips",
                  }}
                />
              </dd>
              <dt>D</dt>
              <dd>
                <Trans
                  i18nKey="InfoboxVar_2"
                  ns="fhwa"
                  values={{
                    unit: isMetric ? "m" : "ft",
                  }}
                />
              </dd>
              <dt>L</dt>
              <dd>
                <Trans
                  i18nKey="InfoboxVar_3"
                  ns="fhwa"
                  values={{
                    unit: isMetric ? "m" : "ft",
                  }}
                />
              </dd>
              <dt>
                d<sub>ult</sub>
              </dt>
              <dd>
                <Trans
                  i18nKey="InfoboxVar_4"
                  ns="fhwa"
                  values={{
                    unit: isMetric ? "kN/m²" : "psi",
                  }}
                />
              </dd>
              <dt>F.S.</dt>
              <dd>
                {t("InfoboxVar_5", {
                  ns: "fhwa",
                })}
              </dd>
              <dt>da</dt>
              <dd>
                <Trans
                  i18nKey="InfoboxVar_6"
                  ns="fhwa"
                  values={{
                    unit: isMetric ? "kN/m²" : "psi",
                  }}
                />
              </dd>
            </dl>
          </Card.Body>
        )}
      </Card>
    </div>
  );
}

export default InfoBox;
